import React from "react";
import axios from "axios";
import SideMenu from "../components/SideMenu";
import { toast } from "react-toastify";

const ChangePassword = ({ user }) => {
  const [loading, setLoading] = React.useState(false);
  const [inputData, setInputData] = React.useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    setInputData({ ...inputData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (inputData.newPassword !== inputData.confirmPassword)
        return toast.error("Password doesn't match");
      if (user) {
        const res = await axios.patch(
          `https://www.api.webdirectories.info/api/auth/update-password/${user._id}`,
          {
            oldPassword: inputData.oldPassword,
            newPassword: inputData.newPassword,
          }
        );
        console.log(res);
        if (res.status === 200) {
          toast.success("Password changed successfully");

          setInputData({
            oldPassword: "",
            newPassword: "",
            confirmPassword: "",
          });
        }
      } else {
        return toast.error("Something went wrong");
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong");
    }
  };

  return (
    <div>
      <div className="container">
        <div className="row flex-nowrap">
          <SideMenu profilePic={user?.profilePic} />
          <div className="col py-3">
            <h2>Change Password</h2>
            <form onSubmit={handleSubmit}>
              <div className="row my-3">
                <div className="col-lg-12">
                  <label className="form-label">Current Password</label>
                  <input
                    className="form-control"
                    type="password"
                    name="oldPassword"
                    value={inputData.oldPassword}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="row my-3">
                <div className="col-lg-12">
                  <label className="form-label">New Password</label>
                  <input
                    className="form-control"
                    type="text"
                    name="newPassword"
                    value={inputData.newPassword}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="row my-3">
                <div className="col-lg-12">
                  <label className="form-label">Confirm New Password</label>
                  <input
                    type="text"
                    className="form-control"
                    name="confirmPassword"
                    value={inputData.confirmPassword}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <button type="submit" className="btn bbtn btn-primary">
                Change Password
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
